<template>
  <div class="background-animation-container" ref="vantaRef">
    <div class="bg"></div>
    <div class="bg bg2"></div>
    <div class="bg bg3"></div>
  </div>
</template>

<script src="./background-animation.js"></script>
<style src="./background-animation.scss" lang="scss"></style>